import Vue from 'vue';
import * as textMaskCore from 'text-mask-core';

Vue.directive('input-mask', {

  inserted: function (el: HTMLInputElement|HTMLSelectElement, binding) {

    const textMaskInputElement = textMaskCore.createTextMaskInputElement({
                                 inputElement: el,
                                 mask: binding.value,
                                 guide: false
                               });

    el.addEventListener('input', (event) => {
      textMaskInputElement.update(event.target['value']);
    });

    el.addEventListener('blur', (event) => {
      textMaskInputElement.update(event.target['value']);
      const fakeEvent = document.createEvent("HTMLEvents");
      fakeEvent.initEvent("input", true, true);
      el.dispatchEvent(fakeEvent);
    });
  }
});



// WEBPACK FOOTER //
// ./src/directives/input-mask/input-mask.ts